"use client";

import { useEffect } from "react";
import { ErrorView } from "@/components/error-view";
import "./globals.css";

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    // Log severe global runtime crash
    console.error("Global Layout boundary caught exception:", error);
  }, [error]);

  return (
    <html lang="en" className="h-full antialiased">
      <body className="min-h-full flex flex-col bg-background text-foreground">
        <main className="flex-1 flex items-center justify-center p-4">
          <ErrorView 
            code="500" 
            title="System Crash Occurred"
            description="The core counseling predictor interface encountered a critical boot exception. Please reload to initialize the dashboard."
            error={error} 
            reset={reset} 
          />
        </main>
      </body>
    </html>
  );
}
